import axios from 'axios'

export const ventasApi = axios.create({
  baseURL: import.meta.env.VENTAS_BASE_URL,
  timeout: 1000 * 60 * 0.8,
  withCredentials: true,
})
